import React, { useEffect, useState, useRef } from 'react';
import $ from 'jquery';
import 'datatables.net-dt/js/dataTables.dataTables.js';
import 'datatables.net-responsive-dt/js/responsive.dataTables.js';
import 'datatables.net-responsive-dt/css/responsive.dataTables.css';
// import 'datatables.net-responsive-dt/js/responsive.dataTables.css';
import { Icon } from '@iconify/react/dist/iconify.js';
import { Link, useNavigate } from 'react-router-dom';
import Select from 'react-select';
import { API_URL } from '..';
import Switch from 'react-switch';
import { GoogleMap, Marker, Circle, useLoadScript } from '@react-google-maps/api';

function formatDate(inputDate) {
    const date = new Date(inputDate);
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const day = date.getUTCDate();
    const month = months[date.getUTCMonth()];
    const year = date.getUTCFullYear();
    return `${day} ${month} ${year}`;
}

const MAPBOX_ACCESS_TOKEN = "pk.eyJ1IjoiemFtcCIsImEiOiJjbTkxa3dkcnMwMmQxMnJzYzBobW9hOHBiIn0.GWvvqPrWqtMby0HYCYdjMQ";

const AppointmentTable = ({ data }) => {
    const history = useNavigate();
    const [electricianList, setElectricianList] = useState([]);
    const [workforceList, setWorkforceList] = useState([]);
    const [selectedElectricians, setSelectedElectricians] = useState([]);
    const [selectedWorkForce, setSelectedWorkForce] = useState([]);
    const [selectedJobId, setSelectedJobId] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [showCustomerInfo, setShowCustomerInfo] = useState(true);
    const [isJobLocationCustomerAddress, setIsJobLocationCustomerAddress] = useState(true);
    const [jobLocation, setJobLocation] = useState("");
    const [jobPostcode, setJobPostcode] = useState("");
    const [jobLocationCoordinates, setJobLocationCoordinates] = useState(null);
    const [referenceNo, setreferenceNo] = useState('');
    const [jobLocationSuggestions, setJobLocationSuggestions] = useState([]);
    const [enableGeofencing, setEnableGeofencing] = useState(false);
    const [radius, setRadius] = useState(100);
    const [mapCenter, setMapCenter] = useState({ lat: 51.5074, lng: -0.1276 });
    const [markerPosition, setMarkerPosition] = useState(null);
    const [errors, setErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    
    const jobLocationInputRef = useRef(null);
    
    const { isLoaded, loadError } = useLoadScript({
        googleMapsApiKey: "AIzaSyBtQlR_uF7q-S8TQblCzLw7Fy7BvyIeXAg",
        libraries: ["places"],
    });

    const mapContainerStyle = {
        width: "100%",
        height: "300px",
        borderRadius: "8px",
        border: "1px solid #ced4da",
    };

    const fetchElectrician = async () => {
        try {
            const response = await fetch(`${API_URL}/api/user/fetch-electrician`, {
                method: "GET",
                headers: { Accept: "*/*", "Content-Type": "application/json" },
            });
            const data = await response.json();
            if (response.status === 200) {
                setElectricianList(data.data.map((e) => ({ label: e.name, value: e.id })));
            }
        } catch (error) {
            console.error("Error fetching electricians:", error);
        }
    };

    const fetchWorkforce = async () => {
        try {
            const response = await fetch(`${API_URL}/api/workforce/select-workforce`, {
                method: "GET",
                headers: { Accept: "*/*", "Content-Type": "application/json" },
            });
            const data = await response.json();
            if (response.status === 200) {
                setWorkforceList(data.data.map((e) => ({ label: e.fullName, value: e.id })));
            } else {
                throw new Error(data.message || "Failed to fetch workforce");
            }
        } catch (error) {
            console.error(error.message);
        }
    };

    const fetchJobDetails = async (jobId) => {
        try {
            const response = await fetch(`${API_URL}/api/job/fetch-single/${jobId}`, {
                method: "GET",
                headers: { Accept: "*/*", "Content-Type": "application/json" },
            });
            const data = await response.json();
            if (response.status === 200) {
                const job = data.job;
                setShowCustomerInfo(job.showCustomerInfo || true);
                setIsJobLocationCustomerAddress(!job.address || job.address === job.customer?.address);
                setJobLocation(job.address || "");
                setJobPostcode(job.postcode || "");
                setEnableGeofencing(job.enableGeofencing || false);
                setRadius(job.radius || 100);
                
                if (job.map_location) {
                    const [latitude, longitude] = job.map_location.split(",").map(Number);
                    setJobLocationCoordinates({ latitude, longitude });
                    setMapCenter({ lat: latitude, lng: longitude });
                    setMarkerPosition({ lat: latitude, lng: longitude });
                }
            }
        } catch (error) {
            console.error("Error fetching job details:", error);
        }
    };

    const fetchCoordinates = async (address) => {
        if (!address) return { latitude: "", longitude: "" };
        try {
            const response = await fetch(
                `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(
                    address
                )}.json?access_token=${MAPBOX_ACCESS_TOKEN}&country=GB`
            );
            const data = await response.json();
            if (data.features?.length > 0) {
                const [longitude, latitude] = data.features[0].geometry.coordinates;
                return { latitude, longitude };
            }
            return { latitude: "", longitude: "" };
        } catch (error) {
            console.error("Error fetching coordinates:", error);
            return { latitude: "", longitude: "" };
        }
    };

    const handleDelete = async (id) => {
        try {
            const apiCall = await fetch(`${API_URL}/api/job/delete-single/${id}`, { method: 'DELETE' });
            if (apiCall.status === 200) {
                window.location.reload();
            }
        } catch (error) {
            console.error("Error deleting job:", error);
        }
    };

    const validateForm = () => {
        const newErrors = {};
        if (!selectedElectricians.length) {
            newErrors.electricians = "At least one electrician is required";
        }
        if (!isJobLocationCustomerAddress) {
            if (!jobLocation) newErrors.jobLocation = "Job location is required";
            if (!jobPostcode) newErrors.jobPostcode = "Job postcode is required";
        }
        if(referenceNo === ""){
            newErrors.referenceNo = "referenceNo is required"
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleAssignElectrician = async () => {
        if (!validateForm()) return;
        
        setIsSubmitting(true);
        try {
            let mapLocation = "";
            if (!isJobLocationCustomerAddress && jobLocation) {
                const coords = await fetchCoordinates(jobLocation);
                mapLocation = coords.latitude && coords.longitude 
                    ? `${coords.latitude},${coords.longitude}`
                    : "";
            } else {
                const job = data.find((j) => j.id === selectedJobId);
                if (job?.map_location) {
                    mapLocation = job.map_location;
                }
            }

            const response = await fetch(`${API_URL}/api/job/assign-electrician/${selectedJobId}`, {
                method: "PUT",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    referenceNo: referenceNo,
                    posted_ids: selectedElectricians.map(e => e.value).toString(),
                    workforce_ids: selectedWorkForce.map((e) => e.value).toString(),
                    showCustomerInfo: showCustomerInfo ? 1 : 0,
                    address: isJobLocationCustomerAddress ? null : jobLocation,
                    postcode: isJobLocationCustomerAddress ? null : jobPostcode,
                    map_location: mapLocation,
                    enableGeofencing: enableGeofencing ? 1 : 0,
                    radius: enableGeofencing ? radius : null,
                }),
            });

            if (response.status === 200) {
                setShowModal(false);
                setSelectedElectricians([]);
                setSelectedWorkForce([]);
                setSelectedJobId(null);
                setJobLocation("");
                setJobPostcode("");
                setJobLocationCoordinates(null);
                setEnableGeofencing(false);
                setRadius(100);
                setErrors({});
                window.location.reload();
            } else {
                throw new Error("Failed to assign electricians");
            }
        } catch (error) {
            console.error("Error assigning electricians:", error);
        } finally {
            setIsSubmitting(false);
        }
    };

    useEffect(() => {
        fetchElectrician();
        fetchWorkforce();

        const user = JSON.parse(localStorage.getItem('user'));

        const table = $('#dataTable').DataTable({
            data: data,
            order: [[0, 'desc']],
            responsive: true,
            pageLength: 10,
            columns: [
                { data: 'id' },
                { data: 'client_name' },
                { data: 'phone' },
                
                {
                    data: 'assignedTo.name',
                    render: function (data, type, row) {
                        return data ? `<span>${data}</span>` : `<span>N/A</span>`;
                    }
                },
                {
                    data: 'createdAt',
                    render: function (data, type, row) {
                        return `<span>${formatDate(data)}</span>`;
                    }
                },
                {
                    data: 'status',
                    render: function (data, type, row) {
                        if (data === 'new') {
                            return `<span class="badge bg-primary">${data}</span>`;
                        } else if (data === 'accepted') {
                            return `<span class="badge bg-warning">${'active'}</span>`;
                        } else if (data === 'declined') {
                            return `<span class="badge bg-danger">${data}</span>`;
                        } else {
                            return `<span class="badge bg-success">${data}</span>`;
                        }
                    }
                },
                {
                    data: null,
                    render: function (data, type, row) {
                        let actions = `
                            <div class="dropdown">
                                <button class="dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    <i class="ph ph-list"></i>
                                </button>
                                <ul class="dropdown-menu">
                                    <li><a style="cursor:pointer" class="dropdown-item view-btn" data-id="${row.id}"><i class="ph ph-eye"></i> View Job</a></li>
                                    <li><a style="cursor:pointer" class="dropdown-item edit-btn" data-id="${row.id}"><i class="ph ph-pencil"></i> Edit Job</a></li>
                                    ${row.job.length === 0 ? `
                                        <li><a style="cursor:pointer" class="dropdown-item create-invoice" data-id="${row.id}"><i class="ph ph-user-plus"></i>Create Order Form</a></li>
                                    ` : ''}
                                    ${row.job.length !== 0 ? `
                                        <li><a style="cursor:pointer" class="dropdown-item view-invoice" data-id="${row.id}"><i class="ph ph-user-plus"></i>View Order Form</a></li>
                                    ` : ''}
                                    ${row.status === 'new' && row.job_posted_to === null ? `
                                        <li><a style="cursor:pointer" class="dropdown-item assign-btn" data-id="${row.id}"><i class="ph ph-user-plus"></i> Assign to Electrician</a></li>
                                    ` : ''}
                                    <li><a style="cursor:pointer" class="dropdown-item delete-btn" data-id="${row.id}"><i class="ph ph-trash"></i> Delete Job</a></li>
                                </ul>
                            </div>
                        `;
                        return actions;
                    },
                    title: 'Actions',
                    orderable: false
                }
            ]
        });

        $('#dataTable tbody').on('click', '.edit-btn', function () {
            const id = $(this).data('id');
            history(`/edit-job/${id}`);
        });

        $('#dataTable tbody').on('click', '.view-btn', function () {
            const id = $(this).data('id');
            history(`/view-job/${id}`);
        });

        $('#dataTable tbody').on('click', '.view-invoice', function () {
            const id = $(this).data('id');
            history(`/view-invoice-job/${id}`);
        });

        $('#dataTable tbody').on('click', '.create-invoice', function () {
            const id = $(this).data('id');
            history(`/create-job-invoice/${id}`);
        });

        $('#dataTable tbody').on('click', '.delete-btn', function () {
            const id = $(this).data('id');
            handleDelete(id);
        });

        $('#dataTable tbody').on('click', '.assign-btn', function () {
            const id = $(this).data('id');
            setSelectedJobId(id);
            fetchJobDetails(id);
            setShowModal(true);
        });

        return () => {
            table.destroy(true);
        };
    }, [data]);

    useEffect(() => {
        const fetchSuggestions = async (query) => {
            if (!query) {
                setJobLocationSuggestions([]);
                return;
            }
            try {
                const response = await fetch(
                    `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(
                        query
                    )}.json?access_token=${MAPBOX_ACCESS_TOKEN}&country=GB`
                );
                const data = await response.json();
                const suggestions = data.features.map((feature) => ({
                    label: feature.place_name,
                    value: feature.place_name,
                    coordinates: feature.geometry.coordinates,
                }));
                setJobLocationSuggestions(suggestions);
            } catch (error) {
                console.error("Error fetching job location suggestions:", error);
            }
        };

        const handleInput = (e) => {
            const value = e.target.value;
            setJobLocation(value);
            setJobLocationCoordinates(null);
            fetchSuggestions(value);
        };

        const jobInput = jobLocationInputRef.current;
        if (jobInput && !isJobLocationCustomerAddress) {
            jobInput.addEventListener("input", handleInput);
        }

        return () => {
            if (jobInput) {
                jobInput.removeEventListener("input", handleInput);
            }
        };
    }, [isJobLocationCustomerAddress]);

    useEffect(() => {
        if (isJobLocationCustomerAddress) {
            const job = data.find((j) => j.id === selectedJobId);
            if (job?.map_location) {
                const [latitude, longitude] = job.map_location.split(",").map(Number);
                setMarkerPosition({ lat: latitude, lng: longitude });
                setMapCenter({ lat: latitude, lng: longitude });
            }
        } else if (jobLocationCoordinates) {
            setMarkerPosition({
                lat: jobLocationCoordinates.latitude,
                lng: jobLocationCoordinates.longitude,
            });
            setMapCenter({
                lat: jobLocationCoordinates.latitude,
                lng: jobLocationCoordinates.longitude,
            });
        }
    }, [isJobLocationCustomerAddress, jobLocationCoordinates, selectedJobId, data]);

    const handleJobLocationSelect = (selected) => {
        if (selected) {
            setJobLocation(selected.value);
            setJobLocationCoordinates({
                latitude: selected.coordinates[1],
                longitude: selected.coordinates[0],
            });
            setJobLocationSuggestions([]);
            setErrors((prev) => ({ ...prev, jobLocation: null }));
        }
    };

    return (
        <div className="card basic-data-table">
            <style>
                {`
                    .form-label {
                        font-weight: 600;
                        color: #343a40;
                    }
                    .form-control, .form-select {
                        border-radius: 8px;
                        padding: 0.75rem;
                        transition: all 0.2s ease;
                    }
                    .form-control:focus, .form-select:focus {
                        border-color: #80bdff;
                        box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
                    }
                    .modal-content {
                        border-radius: 12px;
                        box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
                    }
                    .address-suggestions {
                        position: absolute;
                        z-index: 1000;
                        background: white;
                        border: 1px solid #ced4da;
                        border-radius: 8px;
                        width: 100%;
                        max-height: 200px;
                        overflow-y: auto;
                        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
                        margin-top: 0.25rem;
                    }
                    .address-suggestions li {
                        padding: 0.75rem;
                        cursor: pointer;
                        transition: background-color 0.2s ease;
                    }
                    .address-suggestions li:hover {
                        background-color: #f8f9fa;
                    }
                    .btn-primary {
                        background-color: #007bff;
                        border-color: #007bff;
                    }
                    .btn-primary:disabled {
                        background-color: #6c757d;
                        border-color: #6c757d;
                    }
                    .invalid-feedback {
                        display: block;
                    }
                `}
            </style>
            <div className="card-header">
                <h5 className="card-title mb-0">List of Jobs</h5>
            </div>
            <div className="card-body">
                <table
                    className="table bordered-table mb-0"
                    id="dataTable"
                    data-page-length={10}
                >
                    <thead>
                        <tr>
                            <th scope="col">
                                <div className="form-check style-check d-flex align-items-center">
                                    <label className="form-check-label">S.L</label>
                                </div>
                            </th>
                            <th scope="col">Client Name</th>
                            <th scope="col">Client Phone</th>
                            
                            <th scope="col">Accepted By</th>
                            <th scope="col">Created Date</th>
                            <th scope="col">Status</th>
                            <th scope="col">Action</th>
                        </tr>
                    </thead>
                    <tbody></tbody>
                </table>
            </div>

            {/* Modal for Assigning Electricians */}
            {showModal && (
                <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Assign Electricians</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => {
                                        setShowModal(false);
                                        setSelectedElectricians([]);
                                        setSelectedWorkForce([]);
                                        setJobLocation("");
                                        setJobPostcode("");
                                        setJobLocationCoordinates(null);
                                        setEnableGeofencing(false);
                                        setRadius(100);
                                        setErrors({});
                                    }}
                                ></button>
                            </div>
                            <div className="modal-body">
                            <div className=" mb-3">
                                            <label htmlFor="jobPostcode" className="form-label">
                                                Reference No <span className="text-danger">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className={`form-control ${errors.referenceNo ? "is-invalid" : ""}`}
                                                id="referenceNo"
                                                name="referenceNo"
                                                placeholder="Enter Reference No"
                                                value={referenceNo}
                                                onChange={(e) => setreferenceNo(e.target.value)}
                                            />
                                            {errors.referenceNo && (
                                                <div className="invalid-feedback">
                                                    {errors.referenceNo}
                                                </div>
                                            )}
                                        </div>
                                <div className="mb-3">
                                    <label htmlFor="electricianSelect" className="form-label">
                                        Select Electricians <span className="text-danger">*</span>
                                    </label>
                                    <Select
                                        id="electricianSelect"
                                        options={electricianList}
                                        value={selectedElectricians}
                                        onChange={setSelectedElectricians}
                                        placeholder="Select Electricians"
                                        isMulti
                                        className={errors.electricians ? "is-invalid" : ""}
                                    />
                                    {errors.electricians && (
                                        <div className="invalid-feedback">
                                            {errors.electricians}
                                        </div>
                                    )}
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="workforceSelect" className="form-label">
                                        Select Workforce
                                    </label>
                                    <Select
                                        id="workforceSelect"
                                        options={workforceList}
                                        value={selectedWorkForce}
                                        onChange={setSelectedWorkForce}
                                        placeholder="Select Workforce"
                                        isMulti
                                    />
                                </div>
                                <div className="mb-3">
                                    <div className="form-check form-switch">
                                        <Switch
                                            className="form-check-input"
                                            type="checkbox"
                                            id="showCustomerInfoSwitch"
                                            checked={showCustomerInfo}
                                            onChange={(e) => setShowCustomerInfo(e)}
                                        />
                                        <label
                                            className="form-check-label"
                                            htmlFor="showCustomerInfoSwitch"
                                        >
                                            &nbsp; &nbsp;Show Customer Information to Electrician
                                        </label>
                                    </div>
                                </div>
                                <div className="mb-3">
                                    <div className="form-check form-switch">
                                        <Switch
                                            className="form-check-input"
                                            type="checkbox"
                                            id="jobLocationSwitch"
                                            checked={isJobLocationCustomerAddress}
                                            onChange={(e) => {
                                                setIsJobLocationCustomerAddress(e);
                                                if (e) {
                                                    setJobLocation("");
                                                    setJobPostcode("");
                                                    setJobLocationCoordinates(null);
                                                    setJobLocationSuggestions([]);
                                                    setErrors((prev) => ({
                                                        ...prev,
                                                        jobLocation: null,
                                                        jobPostcode: null,
                                                    }));
                                                }
                                            }}
                                        />
                                        <label
                                            className="form-check-label"
                                            htmlFor="jobLocationSwitch"
                                        >
                                            &nbsp; &nbsp;Job Location is Customer Address
                                        </label>
                                    </div>
                                </div>
                                {!isJobLocationCustomerAddress && (
                                    <div className="row">
                                        <div className="col-md-8 mb-3">
                                            <label htmlFor="jobLocation" className="form-label">
                                                Job Location <span className="text-danger">*</span>
                                            </label>
                                            <div style={{ position: "relative" }}>
                                                <input
                                                    type="text"
                                                    className={`form-control ${errors.jobLocation ? "is-invalid" : ""}`}
                                                    id="jobLocation"
                                                    name="jobLocation"
                                                    placeholder="Enter job location"
                                                    value={jobLocation}
                                                    onChange={(e) => setJobLocation(e.target.value)}
                                                    ref={jobLocationInputRef}
                                                />
                                                {errors.jobLocation && (
                                                    <div className="invalid-feedback">
                                                        {errors.jobLocation}
                                                    </div>
                                                )}
                                                {jobLocationSuggestions.length > 0 && (
                                                    <ul className="address-suggestions">
                                                        {jobLocationSuggestions.map((suggestion, index) => (
                                                            <li
                                                                key={index}
                                                                onClick={() => handleJobLocationSelect(suggestion)}
                                                            >
                                                                {suggestion.label}
                                                            </li>
                                                        ))}
                                                    </ul>
                                                )}
                                            </div>
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <label htmlFor="jobPostcode" className="form-label">
                                                Job Postcode <span className="text-danger">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className={`form-control ${errors.jobPostcode ? "is-invalid" : ""}`}
                                                id="jobPostcode"
                                                name="jobPostcode"
                                                placeholder="Enter postcode"
                                                value={jobPostcode}
                                                onChange={(e) => setJobPostcode(e.target.value)}
                                            />
                                            {errors.jobPostcode && (
                                                <div className="invalid-feedback">
                                                    {errors.jobPostcode}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                )}
                                <div className="mb-3">
                                    <div className="form-check form-switch">
                                        <Switch
                                            className="form-check-input"
                                            type="checkbox"
                                            id="geofencingSwitch"
                                            checked={enableGeofencing}
                                            onChange={(e) => setEnableGeofencing(e)}
                                        />
                                        <label
                                            className="form-check-label"
                                            htmlFor="geofencingSwitch"
                                        >
                                            &nbsp; &nbsp;Enable Geofencing
                                        </label>
                                    </div>
                                </div>
                                {enableGeofencing && (
                                    <>
                                        <div className="mb-3">
                                            <label htmlFor="radiusInput" className="form-label">
                                                Geofence Radius (meters)
                                            </label>
                                            <input
                                                type="number"
                                                id="radiusInput"
                                                className="form-control"
                                                min="50"
                                                max="5000"
                                                value={radius}
                                                onChange={(e) => setRadius(parseInt(e.target.value) || 100)}
                                            />
                                            <div className="form-text">
                                                Set the radius for the geofence area around the location.
                                            </div>
                                        </div>
                                        {loadError && (
                                            <div className="alert alert-danger">
                                                Error loading Google Maps. Please try again later.
                                            </div>
                                        )}
                                        {!isLoaded ? (
                                            <div>Loading Google Maps...</div>
                                        ) : (
                                            <div className="mb-3">
                                                <GoogleMap
                                                    mapContainerStyle={mapContainerStyle}
                                                    center={mapCenter}
                                                    zoom={14}
                                                    options={{
                                                        streetViewControl: false,
                                                        mapTypeControl: false,
                                                        fullscreenControl: false,
                                                    }}
                                                >
                                                    {markerPosition && (
                                                        <>
                                                            <Marker position={markerPosition} draggable={false} />
                                                            <Circle
                                                                center={markerPosition}
                                                                radius={radius}
                                                                options={{
                                                                    strokeColor: "#FF0000",
                                                                    strokeOpacity: 0.8,
                                                                    strokeWeight: 2,
                                                                    fillColor: "#FF0000",
                                                                    fillOpacity: 0.35,
                                                                }}
                                                            />
                                                        </>
                                                    )}
                                                </GoogleMap>
                                                <div className="form-text">
                                                    Map showing the job location and geofence area.
                                                </div>
                                            </div>
                                        )}
                                    </>
                                )}
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={() => {
                                        setShowModal(false);
                                        setSelectedElectricians([]);
                                        setSelectedWorkForce([]);
                                        setJobLocation("");
                                        setJobPostcode("");
                                        setJobLocationCoordinates(null);
                                        setEnableGeofencing(false);
                                        setRadius(100);
                                        setErrors({});
                                    }}
                                >
                                    Close
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={handleAssignElectrician}
                                    disabled={isSubmitting || selectedElectricians.length === 0}
                                >
                                    {isSubmitting ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                            Submitting...
                                        </>
                                    ) : (
                                        "Submit"
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AppointmentTable;